import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { VenueModalFooter } from '../SharedModalComponents/VenueModalFooter';
import { ServiceModalHeader } from 'venue/components/SharedModalComponents';
import { hideServiceChoiceModal } from 'venue/actions';
import { Notification } from 'core/components/Notification';
import { ModalHeader, ModalBody } from 'components/Modal';
import { ServiceModalContext } from 'contexts/ServiceModalContext';
import { TableSelector } from 'features/table/components/TableSelector';
import { useVenues } from 'contexts/VenueContext';
import { useTables } from 'contexts/TableContext/TableContext';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { ReactSelectOption } from 'types/react-select-virtualized';
import { useTimeslots } from 'contexts/TimeslotContext/TimeslotContext';

interface TableSelectorFormProps {
  tableSelector: ReactSelectOption;
}

export const SelectedServiceOrderAndPay: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { onClose } = useContext(ServiceModalContext);
  const { selectedVenue } = useVenues();
  const { setSelectedTable } = useTables();
  const { setSelectedTimeslot } = useTimeslots();
  const methods = useForm<TableSelectorFormProps>();

  const handleConfirm: SubmitHandler<TableSelectorFormProps> = (formValues) => {
    setSelectedTable(formValues.tableSelector);
    dispatch(hideServiceChoiceModal());
    setSelectedTimeslot(undefined);
    history.push(`/venue/${selectedVenue?.id}/order-and-pay/menus`);
  };

  return (
    <FormProvider {...methods}>
      <ModalHeader closeButton onRequestClose={() => onClose(true)}>
        <ServiceModalHeader useDistanceIfAvailable />
      </ModalHeader>
      <ModalBody>
        <Notification />
        <TableSelector />
      </ModalBody>
      <VenueModalFooter
        handleConfirm={methods.handleSubmit(handleConfirm)}
        disabled={false}
      />
    </FormProvider>
  );
};
